import React, { Component } from 'react'
import PascalElement from './PascalElement';

import 'katex/dist/katex.min.css';
import TeX from '@matejmazur/react-katex';
import style from './PascalTriangle.module.css';

export default class PascalTriangle extends Component {

    state = {
        selectedDisplay: 0
    };

    displayChanger = (displayMode) => () => {
        this.setState({ selectedDisplay: displayMode });
        console.log('Selected ' + displayMode);
    }


    render() {
        const triangle = [...Array(6).keys()].map((_, i) => {
            const row = [];

            for (let x = 0; x < i + 1; x++) {
                row.push(
                    <PascalElement n={i} k={x} key={"PascEl_" + x + "_" + i} toggle={this.state.selectedDisplay} />
                );
                if (i > 0 && (x < i) && this.state.selectedDisplay === 2) {
                    row.push(
                        <div key={"plus_" + x + "_" + i}>+</div>
                    )
                }
            }
            return (
                <div key={"row" + "_" + i} className={style.PascalRow}>
                    {row}
                </div>
            );
        });

        return (
            <>
                <div className={style.ButtonBox}>
                    <button key="1" onClick={this.displayChanger(0)} className={style.Button1}>Show <TeX math="n \choose k" /> </button>
                    <button key="2" onClick={this.displayChanger(1)} className={style.Button1}>Show Coefficients</button>
                    <button key="3" onClick={this.displayChanger(2)} className={style.Button1}>Show Expanded Terms</button>
                </div>

                <div>
                    {triangle}
                </div >
            </>
        )
    }
}
